import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import { Horario } from "@/models/horario";

const horario = require("@/query/linhas-regulares/Horario.graphql");

export class HorarioAPI extends BaseAPI<Horario> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/linhas-regulares`;
  }

  public findBy(linhaId: number): AxiosObservable<Horario[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(horario),
        variables: {
          idLinha: linhaId,
        },
      })
      .pipe(
        map((data: any) => {
          const { horarios } = data;

          return horarios.map(
            (horario: any) =>
              new Horario(
                horario.id,
                horario.descricao,
                horario.possuiCobrador,
                horario.horaSaida,
                horario.saidaInicial,
                horario.origemDescricao,
                horario.linhaId
              )
          );
        })
      );
  }
}
